module.exports = __webpack_public_path__ + "img/TADA.7f7598df.png";